import { Form, Input, Row, Col, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import { convert } from 'html-to-text';
import { getService } from '../../system/WebUniversal';

const WebEdit = (props: any) => {
    const { editMode } = props;
    const [form] = Form.useForm(); //form 
    const ref = useRef<any>(undefined);

    const [id, setId] = useState<string>();

    useEffect(() => {
        ref.current.getRow.then((res: any) => {
            if (res.success) {
                setId(res?.data?.id);
            }
        })
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        apiId: 'emailTemplate',
        serviceId: 'business',
        displayOptions: {
            width: 1080
        },
        disabledOptions: {
            isOnKeyDownEnter: false
        },
        formOptions: {
            instance: form,
            children: (<Row gutter={[8, 0]}>
                <Col span={8}>
                    <Form.Item
                        label="id"
                        name="id"
                        tooltip='不输入id可生成随机id'>
                        <Input disabled={editMode === 'NEW' ? false : true} />
                    </Form.Item>
                </Col>

                <Col span={16}>
                    <Form.Item
                        label="名称"
                        name="templateName"
                        rules={[{ required: true, message: '名称!' }]}>
                        <Input />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item
                        label="内容"
                        name="htmlContent"
                        tooltip='邮件模版html内容'>
                        <WangeditorV5ForAntD
                            key={id}
                            id={`emailTemplate${id}`}
                            defaultService={getService()}
                            displayMode="editor"
                            style={{ height: 500 }}
                            onChange={(e) => {
                                form.setFieldValue('textContent', convert(e));
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item label="文字"
                        name="textContent"
                        tooltip='邮件模版纯文字，通过内容生成'>
                        <Input.TextArea
                            autoSize={{ minRows: 1, maxRows: 6 }}
                            disabled={true}
                        />
                    </Form.Item>
                </Col>

                <Col span={5}>
                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>
                </Col>

            </Row>)
        }
    };

    return (
        <WebEditUniversal ref={ref} {...extendProps} />
    )
}

export default WebEdit;